import { z } from 'zod';
/**
 * App Storage Document Schema
 * Documents in app-scoped collections have arbitrary shape
 */ export const AppStorageDocumentSchema = z.object({
    _id: z.string(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional()
}).catchall(z.unknown());
/**
 * App Storage List Response Schema
 * GET /api/v2/apps/:appId/storage/:collection
 */ export const AppStorageListResponseSchema = z.object({
    data: z.array(AppStorageDocumentSchema)
});
/**
 * App Storage Get Response Schema
 * GET /api/v2/apps/:appId/storage/:collection/:id
 */ export const AppStorageGetResponseSchema = z.object({
    data: AppStorageDocumentSchema.nullable()
});

//# sourceMappingURL=app-storage.schema.js.map